/**
 * This module contains the UI
 * to build the setVariable instruction category
 */

// TODO:
// - reduce unneeded notifications
// - unbind events of removed UI elements
// - unify styles

(function() {
  const $ = require('jQuery');
  const instruction_widgets = require('../instruction_widgets');
  const io_widgets = require('../instruction_widgets/io_widgets');
  const icons = require('../../icons');
  const widgets = require('../widgets');
  const utils = require('./utils');
  const helpers = require('../../helpers');
  const ml = require('../../machinelogic');

  const { autocompleteComponent } = require('../vse_ui/vse_components/base_components');

  function create(pParameters) {
    const lLibrary = pParameters.library;
    const lApp = pParameters.application;
    const lSequence = pParameters.sequence;
    const lInstruction = pParameters.instruction;
    const _lDiv = $('<div class="ml_instruction h_layout"/>');
    const _lCard = widgets.card(icons[lInstruction.getCategory()], function () {
      lSequence.removeInstruction(lSequence.getInstructionIndex(lInstruction));
    }).attr('id', widgets.idGenerator.nextInstructionId());
    const _lParameterMap = {};
    let _lFilteredActionsSet;
    // Note (alevy): this function does not return a widget
    // it adds widgets to _lCard
    const _parameterWidget = function (pParameterInfo, pParameter) {
      let _lWidget;
      switch (pParameterInfo.format) {
        // Note(alevy): build set variable instruction
        case 'oneOf':
          if (pParameterInfo.unit == 'ioExpander' && pParameterInfo.name == 'inputUuid') {
            _lWidget = io_widgets.inputParamWidget(
              lLibrary.getConfigManager(),
              'Input Name',
              pParameterInfo.description,
              pParameterInfo.default == ml.reservedUuids.NONE,
              lInstruction.getParameter(pParameter),
              function (pValue) {
                lInstruction.setParameter(pParameter, pValue);
              },
              pParameterInfo.allowPneumatic);
          }
          else if(pParameterInfo.unit === "axis" && pParameterInfo.name === "axis") {
            const lParameter = lInstruction.getParameter(pParameter);
            const lConfigManager = lLibrary.getConfigManager();
            const lName = pParameterInfo.name;
            const lTooltip = pParameterInfo.description;
            const lAllowedAxisType = pParameterInfo.allowedAxisType;
            const lOnValue = (pValue) => {
              lInstruction.setParameter(pParameter, pValue);
            };

            _lWidget = instruction_widgets.axisParamWidget(
              lConfigManager,
              lInstruction,
              lParameter,
              lName,
              lTooltip,
              false,
              lAllowedAxisType,
              lParameter,
              lOnValue
            );
          }
          else {
            _lWidget = widgets.listWidget(pParameterInfo.name, pParameterInfo.values, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, pValue);
            });
          }
          break;
        case 'string':
          if (pParameterInfo.unit == 'variables') {
            for (const applicationParameterKey in lApp.mParameters.mParameters){
              const applicationParameter = lApp.mParameters.mParameters[applicationParameterKey];
              if (applicationParameter.type === "const") {
                pParameterInfo.default = applicationParameter.name;
                break; // use the first application parameter "const" as the default variable
              }
            }
            const validInputIsAListOfVariables = (value) => {
              const lInputedVariableList = value.split(',').map(each => each.trim());
              const lInvalidVariable = lInputedVariableList.find(pVariable => !lApp.listAllApplicationParameterNames().includes(pVariable));

              if (lInvalidVariable === undefined ) { return; }
              else if (lInvalidVariable.length === 0) { return 'Invalid input'; }
              else { return `${lInvalidVariable} is not a valid variable`; }
            };
            _lWidget = autocompleteComponent(
              helpers.transformToTitleCase(pParameterInfo.name),
              pParameterInfo.description,
              lInstruction.getParameter(pParameter),
              lApp.listAllApplicationParameterNames(),
              (pValue) => { lInstruction.setParameter(pParameter, pValue); },
              [validInputIsAListOfVariables, helpers.required ],
            ).widget;
          } else if (pParameterInfo.unit == 'variable') {
            _lWidget = instruction_widgets.variableListWidget(pParameterInfo.name, lApp, pParameterInfo.description, lInstruction.getParameter(pParameter), function(pValue) {
              lInstruction.setParameter(pParameter, pValue);
            });
          } else if (pParameterInfo.unit == 'expression') {
            _lWidget = autocompleteComponent(
              helpers.transformToTitleCase(pParameterInfo.name),
              pParameterInfo.description,
              lInstruction.getParameter(pParameter),
              lApp.listAllApplicationParameterNames(),
              (pValue) => { lInstruction.setParameter(pParameter, pValue); },
              [helpers.getExpressionValidationFunction(lApp.getParametersObject()), helpers.required],
            ).widget;
          } else if (pParameterInfo.name === 'eventTopic') {
            _lWidget = widgets.stringWidget(pParameterInfo.name, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              _lWidget.children('input').attr('title', pValue);
              lInstruction.setParameter(pParameter, pValue);
            });
          }
          break;

        default:
          _lWidget = widgets.baseWidget(pParameterInfo.name).append($('<div>' + pParameterInfo.format + ' not supported</div>'));
          break;
      }

      if (_lWidget) {
        _lWidget.addClass('v_layout spaced');
        _lParameterMap[pParameter] = _lWidget;
        _lCard.parameters.append(_lWidget);
      }
    };
    const _lActionSet = lLibrary.getInstructionSet()[lInstruction.getCategory()];
    let _lActions;
    const _onAction = function (pAction) {

      if(pAction === "fromActuatorPosition"){
        const lAllowedAxisTypes = _lActionSet[pAction].parameters.find(item => item.name === "axis")?.allowedAxisType;
        const lAxes = lApp.mLibrary.getConfigManager().listAxes();
        const hasAllowedAxisType = lAxes.filter(item =>  lAllowedAxisTypes.includes(item.getType())).length > 0;

        if(lAxes.length === 0) {
          widgets.messageBox('Please configure an actuator before using this command. Your changes have been reverted.', 'warning');
          return lInstruction.setName(lInstruction.getName());
        }
        else if (!hasAllowedAxisType){
          widgets.messageBox('This command does not work with pneumatic actuators and AC Motors. Your changes have been reverted.', 'warning');
          return lInstruction.setName(lInstruction.getName());
        }
      }



      if (['fromDevice'].includes(pAction)) {
        const lIsDeviceAvailable = lLibrary.getConfigManager().numberOfInputs() > 0;
        if (!lIsDeviceAvailable) {
          widgets.messageBox('Please configure an input before using it. Your changes have been reverted.', 'warning');
          _lActions.setValue(lInstruction.getName());
          return;
        }
      }
      lInstruction.setName(pAction);
    };
    const buildInstruction = utils.buildInstruction(_parameterWidget);

    _lCard.icon.find('h5').addClass('ml_number');
    _lCard.icon.removeClass('ml_icon').addClass('ml_icon_instruction_widget');

    if (_lActionSet) {
      // Please see VentionCo/mm-vention-control#569
      _lFilteredActionsSet = utils.getActions(lLibrary, lInstruction);
      _lActions = widgets.listWidget(lInstruction.getCategory(), utils.getActionList(_lFilteredActionsSet), 'Action to be performed', lInstruction.getName(), _onAction);
      buildInstruction(_lCard, lInstruction, _lActions, _lFilteredActionsSet);
      _lCard.append($('<div class="ml_animated_background"/>'));
      _lDiv.append(_lCard);

      const lInstructionListeners = utils.getInstructionListener({
        actions: _lActions,
        buildInstruction: buildInstruction,
        card: _lCard,
        filteredActionsSet: _lFilteredActionsSet,
        instruction: lInstruction,
        library: lLibrary,
        parameterMap: _lParameterMap,
      });

      // Instruction and Application listeners
      lInstruction.addListener(lInstructionListeners);

      _lDiv.on('remove', function onRemoveTriggerInstruction() {
        lInstruction.removeListener(lInstructionListeners);
      });
    }


    return _lDiv;
  }
  /* Module export glue */
  /* global define */
  const gExports = {
    create: create,
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }

})();
